import { SelectFields } from '@repo/toolkit/types'

import { AAKeyword } from '../../lib/types/models/aa-keywords/aa-keyword'
import { FieldsSelector } from '../../lib/types/utils'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getAAKeyword<T extends FieldsSelector<AAKeyword>>(id: number, fields: T) {
  return restApiClient
    .url(encodeNestedObject(constructApiUrl(API.aAKeyWords.get.url, { id }), { fields }))
    .get<SelectFields<AAKeyword, T>>()
}
